import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
import { getIconByName } from '../../../utils/iconMap';
/**
 * LinkList – list of links with optional icons. Supports label + gradient.
 */
const LinkList = ({ label, gradient, title, links = [], titleColor, titleFontSize, linkColor, linkFontSize, iconColor, accentColor, paddingTop, paddingBottom, paddingLeft, paddingRight, marginTop, marginBottom, maxWidth, width, borderRadius = 2, border, backgroundColor, fontFamily, fontWeight = 600, componentAlignment = 'left', }) => {
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.hero)
        : backgroundColor || 'transparent';
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 3,
            paddingBottom: paddingBottom || 3,
            paddingLeft: paddingLeft || 0,
            paddingRight: paddingRight || 0,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: { maxWidth: maxWidth || 480, mx: 'auto', px: 2 }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 2, color: 'text.secondary', letterSpacing: 1 }, children: label })), title && (_jsx(Typography, { sx: {
                        fontSize: titleFontSize || '1.5rem',
                        fontWeight: Number(fontWeight) || 700,
                        fontFamily: fontFamily || undefined,
                        mb: 2,
                        color: titleColor || 'text.primary',
                    }, children: title })), _jsx(List, { sx: { py: 0 }, children: links.map((link, index) => {
                        const IconComponent = getIconByName(link.icon || 'ArrowForward');
                        return (_jsxs(ListItem, { component: "a", href: link.url, sx: {
                                py: 1.5,
                                px: 2,
                                mb: 1,
                                backgroundColor: 'background.paper',
                                borderRadius: typeof borderRadius === 'number' ? borderRadius : borderRadius,
                                border: border || '1px solid',
                                borderColor: 'divider',
                                textDecoration: 'none',
                                color: 'inherit',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    borderColor: accentColor || 'primary.main',
                                    transform: 'translateX(4px)',
                                },
                            }, children: [_jsx(ListItemIcon, { sx: { minWidth: 40, color: iconColor || accentColor || 'primary.main' }, children: _jsx(IconComponent, {}) }), _jsx(ListItemText, { primary: link.text, primaryTypographyProps: {
                                        fontWeight: Number(fontWeight) || 600,
                                        fontSize: linkFontSize,
                                        fontFamily: fontFamily || undefined,
                                        color: linkColor || 'text.primary',
                                    } })] }, index));
                    }) })] }) }));
};
export default LinkList;
